var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeriod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 16.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #428bca;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_738286_cc",
    transform: "translate(-10 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    className: "cls-1",
    d: "M27.55,15.25H23.725v-1.8a.45.45,0,1,0-.9,0v1.8h-7.65v-1.8a.45.45,0,0,0-.9,0v1.8H10.45a.45.45,0,0,0-.45.45V29.2a.45.45,0,0,0,.45.45h17.1A.45.45,0,0,0,28,29.2V15.7A.45.45,0,0,0,27.55,15.25Zm-13.275.9V17.5a.45.45,0,1,0,.9,0V16.15h7.65V17.5a.45.45,0,1,0,.9,0V16.15H27.1V20.2H10.9V16.15ZM10.9,28.75V21.1H27.1v7.65Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeriod);
export default __webpack_public_path__ + "static/media/period.cc99a15e0cf64bee6b949ac302e16c33.svg";
export { ForwardRef as ReactComponent };